import { detectMobileDevice } from '@hourly/utilities';
import { Navigate, useNavigate, useSearchParams } from 'react-router';
import Loader from '../_shared/components/Loader';
import CantLogin from './components/CantLogin';
import CodeVerification from './components/CodeVerification';
import MagicLinkSent from './components/MagicLinkSent';
import SignIn from './components/SignIn';
import { LoginStep, useLogin } from './data/hooks/useLogin';

const Login = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const isMobile = detectMobileDevice();
  const magicLinkToken = params.get('mt');

  const { step, isLoading, verificationCodeError, loginUser, verifyCode } = useLogin(
    magicLinkToken,
    isMobile
  );

  const handleVerifyCode = async (code: string) => {
    verifyCode(
      { code, magic_token: magicLinkToken! },
      {
        onSuccess: (partner) => {
          const navigationPath = partner.isInOnboarding ? '/onboarding' : '/referrals';
          navigate(navigationPath);
        },
      }
    );
  };

  if (isMobile) {
    return <Navigate to="/mobile-unsupported" />;
  }

  if (isLoading) {
    return <Loader />;
  }

  if (step === LoginStep.SignIn) {
    return <SignIn disabled={isLoading} onSubmit={(email) => loginUser({ email })} />;
  }

  if (step === LoginStep.MagicLinkSent) {
    return <MagicLinkSent onReturn={() => navigate('/')} />;
  }

  if (step === LoginStep.CantLogin) {
    return <CantLogin onReturn={() => navigate('/')} />;
  }

  if (step === LoginStep.CodeVerification && magicLinkToken) {
    return (
      <CodeVerification
        error={verificationCodeError}
        onSubmit={handleVerifyCode}
        onReturn={() => navigate('/')}
      />
    );
  }

  return <SignIn disabled={isLoading} onSubmit={(email) => loginUser({ email })} />;
};

export default Login;
